import { isSupabaseConfigured } from './supabaseContent';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_KEY =
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY ||
  process.env.REACT_APP_SUPABASE_ANON_KEY;

const ARROW_COLORS = {
  green: '#22c55e',
  red: '#ef4444',
  blue: '#3b82f6',
  yellow: '#f59e0b',
  orange: '#f97316',
  purple: '#a855f7',
  gray: '#64748b'
};

async function apiGet(path) {
  const response = await fetch(`${SUPABASE_URL}${path}`, {
    headers: {
      apikey: SUPABASE_KEY,
      Authorization: `Bearer ${SUPABASE_KEY}`
    }
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(`Supabase request failed: ${response.status} ${message}`);
  }

  return response.json();
}

export async function fetchStepAnnotations(stepId) {
  if (!isSupabaseConfigured() || !stepId) return null;

  const annotations = await apiGet(
    `/rest/v1/step_annotations?lesson_step_id=eq.${stepId}&select=annotation_type,from_square,to_square,square,color,payload`
  );

  const arrows = [];
  const highlights = [];
  let arrowColor = null;

  for (const a of annotations) {
    const colorName = (a.color || '').toLowerCase();
    const colorValue = ARROW_COLORS[colorName] || null;

    if (a.annotation_type === 'arrow' && a.from_square && a.to_square) {
      arrows.push([a.from_square, a.to_square]);
      arrowColor = arrowColor || colorValue || ARROW_COLORS.green;
      continue;
    }

    if (a.annotation_type === 'highlight' && a.square) {
      highlights.push({ square: a.square, color: colorValue || '#fde68a', payload: a.payload || {} });
    }
  }

  const customSquareStyles = {};
  for (const h of highlights) {
    customSquareStyles[h.square] = {
      boxShadow: `inset 0 0 0 4px ${h.color}`,
      borderRadius: '6px'
    };
  }

  return {
    customArrows: arrows,
    customArrowColor: arrowColor || ARROW_COLORS.green,
    customSquareStyles
  };
}

export async function fetchStepAnnotationsByLessonAndOrder(lessonId, stepOrder) {
  if (!isSupabaseConfigured() || !lessonId || !stepOrder) return null;

  // Resolve the current lesson_step id (useful in dev if steps are reseeded and ids changed).
  const steps = await apiGet(
    `/rest/v1/lesson_steps?lesson_id=eq.${lessonId}&step_order=eq.${Number(stepOrder)}&select=id&limit=1`
  );
  const step = steps && steps[0];
  if (!step?.id) return null;
  return fetchStepAnnotations(step.id);
}
